import React from 'react';
import { Link } from 'react-router';
import { object, string } from 'prop-types';


const ExternalLink = ({ ...props }) => {

  let url = props.url;
  
  // Prepend http if it was not provided
  if (url.indexOf('http') === -1) {
    url = `http://${url}`;
  }

  // preventDefault() prevents the link opening in two tabs/windows, and we want the url to completely
  // replace the current window url
  const clickHandler = (event) => {
    event.preventDefault();
    window.open(url, '_blank');
  };

  // If there is no label prop, return the image or icon passed in. If no label this will fail.
  const renderLinkContent = () => {
    if (props.label) {
      return props.label;
    }

    return props.icon;
  };

  const link =
    <Link
      className={props.className}
      to={url}
      id={props.id}
      title={props.title}
      onClick={clickHandler}
    >
      {renderLinkContent()}
    </Link>;

  return (url ? link : false);

};

// Can either display text or an image/icon or both as part of the content for the Link
ExternalLink.propTypes = {
  className: string,
  label: string.isRequired,
  icon: object,
  id: string.isRequired,
  title: string.isRequired,
  url: string.isRequired,
};

export default ExternalLink;



// WEBPACK FOOTER //
// ./src/components/ExternalLink/ExternalLink.js